module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct_no_cn"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pagev",
      "title": "v"
    }
  }), _c('a', {
    attrs: {
      "href": "#/Text/Contents#Ded"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Dedication")])])]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pagevi",
      "title": "vi"
    }
  }), _vm._v("For Saman Gunan, who sacrificed everything"), _c('br'), _vm._v("and"), _c('br'), _vm._v("Paul Gutman, for whom rescue was impossible")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26f07315","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Dedication.vue
// module id = 63
// module chunks = 0